import { OptionDefinition } from '@amzn/awsui-components-react-v3/polaris/internal/components/option/interfaces';

import { RequestPropertyIds } from '../../../../data/BackendEntityConstants';
import { Property } from '../../../../interfaces/RFXBackendModel';
import { RFXRequestGeneralInformation } from '../../../../interfaces/RFXRequestForm';
import { shouldSupportMultipleCategories, shouldSupportMultipleRegions } from '../../../BusinessUtils';
import { createProperty } from '../../../RFXUtils';
import { getWorkflowFromGeneraInfo } from '../../../WorkflowUtils';
import { convertCategories, convertRegions } from '../../common/backendConverter';

/**
 * Convert the category/categories inside general information to properties and add it to the existing properties
 * 
 * @param generalInfo general information options from UI
 * @param properties existing properties
 */
export function convertCategoryOptions(generalInfo: RFXRequestGeneralInformation, properties: Property[]) {
  if (shouldSupportMultipleCategories(generalInfo.businessId)) {
    let categroies: string[] = [];
    if (generalInfo.categories) {
      categroies = generalInfo.categories
        .filter((category: OptionDefinition) => category.label !== '')
        .map((category: OptionDefinition) => category.label!);
    }
    if (categroies.length === 0) {
      throw new Error('Category is required.');
    }
    properties.push(convertCategories(categroies));
  } else {
    if (generalInfo.category?.value && generalInfo.category.label !== '') {
      properties.push(createProperty(RequestPropertyIds.Category, generalInfo.category.label!));
    } else {
      throw new Error('Category is required.');
    }
  }
}

/**
 * Convert the region/regions inside general information to properties and add it to the existing properties
 * 
 * @param generalInfo general information options from UI
 * @param properties existing properties
 */
export function convertRegionOptions(generalInfo: RFXRequestGeneralInformation, properties: Property[]) {
  const rfxType = generalInfo.rfxType;
  const businessId = generalInfo.businessId!;
  const workflow = getWorkflowFromGeneraInfo(generalInfo) ?? businessId;
  if (shouldSupportMultipleRegions(rfxType, businessId, workflow)) {
    let regions: string[] = [];
    if (generalInfo.regions) {
      regions = generalInfo.regions
        .filter((region: OptionDefinition) => region.label !== '')
        .map((region: OptionDefinition) => region.label!);
    }
    if (regions.length === 0) {
      throw new Error('Region is required.');
    }
    properties.push(convertRegions(regions));
  }
}
